import { render, staticRenderFns } from "./TranslationsTable.vue?vue&type=template&id=5e0a162e&"
import script from "./TranslationsTable.vue?vue&type=script&lang=js&"
export * from "./TranslationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports